import type {GeocodingResponseType} from './GeocodingResponseType';

/**
 * Performs a geocoding request (coordinates lookup) and returns the parsed result
 */
export const performGeocode = async (
  apiKey: string,
  address: string,
  language = 'en'
): Promise<GeocodingResponseType> => {
  let urlStr = 'https://maps.googleapis.com/maps/api/geocode/json'
  urlStr += `?address=${encodeURIComponent(address)}`
  urlStr += `&key=${apiKey}`
  urlStr += `&language=${language}`

  const response = await fetch(urlStr);
  return await response.json();
}
